/**
 * Generating header content
 * @param seasonalityConfig
 * @param selMnthStlmts
 * @param settlementThreshold
 * @returns
 */
export const seasonalityHeaderContent = (
  seasonalityConfig: any,
  selMnthStlmts: number = 0,
  settlementThreshold: number = 0
) => {
  const seasonalityMonths: any = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];
  const currentMonthNumber: number = new Date().getMonth();
  const currentMonthText: string = seasonalityMonths[currentMonthNumber];
  const nextMonthNumber: number = currentMonthNumber + 1;
  const nextMonthText: string = seasonalityMonths[nextMonthNumber] ? seasonalityMonths[nextMonthNumber] : seasonalityMonths[0];
  let textContent = { text: "", textColor: "", nextSeasonality: "", isSeasonalityApplied: false };
  
  if (seasonalityConfig) {
    if (seasonalityConfig[currentMonthText] !== 0 && selMnthStlmts > settlementThreshold) {
      textContent.text = `S-${selMnthStlmts}`;
      textContent.textColor = "red";
      textContent.nextSeasonality = `${
        seasonalityConfig[currentMonthText] !== 0
          ? currentMonthText.toUpperCase() + " " + seasonalityConfig[currentMonthText] + "%"
          : ""
      }`;
      textContent.nextSeasonality += `${
        nextMonthText && seasonalityConfig[nextMonthText] !== 0
          ? " | " + nextMonthText.toUpperCase() + " " + seasonalityConfig[nextMonthText] + "%"
          : ""
      }`;
      textContent.isSeasonalityApplied = true;
    } else if (seasonalityConfig[currentMonthText] !== 0) {
      textContent.text = `S-${selMnthStlmts}`;
      textContent.textColor = "green";
      textContent.nextSeasonality = `${
        seasonalityConfig[currentMonthText] !== 0
          ? currentMonthText.toUpperCase() + " " + seasonalityConfig[currentMonthText] + "%"
          : ""
      }`;
      textContent.nextSeasonality += `${
        nextMonthText && seasonalityConfig[nextMonthText] !== 0
          ? " | " + nextMonthText.toUpperCase() + " " + seasonalityConfig[nextMonthText] + "%"
          : ""
      }`;
      textContent.isSeasonalityApplied = true;
    } else if (!seasonalityConfig[currentMonthText]) {
      for (let i = nextMonthNumber; i < seasonalityMonths.length; i++) {
        if (seasonalityConfig[seasonalityMonths[i]] !== 0) {
          textContent.text = `S`;
          textContent.textColor = "grey";
          break;
        }
      }
    }
  }
  return textContent;
};
